export const TabJSXConverter = {
  tab: '\t'
};
//# sourceMappingURL=tab.js.map